"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverablesService = void 0;
class DeliverablesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Delete a deliverables
     * @param id
     * @returns CampaignDeliverableDeletionParam
     * @throws ApiError
     */
    deleteDeliverable(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/deliverables/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deliverable
     * @param id
     * @param requestBody
     * @returns CampaignDeliverableParam
     * @throws ApiError
     */
    updateDeliverable(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deliverables/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate test brief
     * @param requestBody
     * @returns TestBriefResponse
     * @throws ApiError
     */
    generateTestBrief(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deliverables/brief',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Check that the file of a deliverable has the correct permissions
     * @param requestBody
     * @returns CheckFilePermissionResponse
     * @throws ApiError
     */
    checkFilePermission(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deliverables/file/permission',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deliverables search. Pass query string with the filters you wish to apply.
     * @param sort
     * @param filter
     * @param page
     * @param count
     * @returns DeliverableSearchResult
     * @throws ApiError
     */
    searchDeliverables(sort, filter, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deliverables/search',
            query: {
                'sort': sort,
                'filter': filter,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Deliverables search download
     * @param sort
     * @param filter
     * @param format
     * @param page
     * @param count
     * @returns any Successful response
     * @throws ApiError
     */
    searchDeliverablesDownload(sort, filter, format, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deliverables/search/download',
            query: {
                'sort': sort,
                'filter': filter,
                'format': format,
                'page': page,
                'count': count,
            },
        });
    }
}
exports.DeliverablesService = DeliverablesService;
